import { TCountryCode } from 'countries-list';
import quantize from '../helpers/quantize';
import UI from '../ui';
import colors from '../ui/colors';

const getCategoryName: (countriesCount: number) => string = (countriesCount) => {
  if (countriesCount > 50) {
    return 'World Citizen';
  }
  else if (countriesCount > 30) {
    return 'Globe Trotter';
  }
  else if (countriesCount > 15) {
    return 'Nomad';
  }
  else if (countriesCount > 5) {
    return 'Voyager';
  }
  else {
    return 'Roamer';
  }
};

const TravelerStatus: React.FC<{ countries: TCountryCode[], name?: string }> = ({ countries, name }) => {
  return (
    <div style={{ height: '100px', width: '100%', backgroundColor: colors.greige, paddingLeft: '15px', paddingRight: '15px' }}>
      <UI.VerticalLayout height="100%" justify="center">
        {countries.length > 0
          ? (
              <UI.VerticalLayout>
                {name
                  ? (
                      <UI.Text size="subtitle" weight="bold">
                        {name}
                        {' '}
                        has travelled&nbsp;
                        {quantize(countries.length, { singular: 'country', plural: 'countries' })}
                        .
                        {' '}
                        {name}
                        {' '}
                        is a:
                      </UI.Text>
                    )
                  : (
                      <UI.Text size="subtitle" weight="bold">
                        You've travelled&nbsp;
                        {quantize(countries.length, { singular: 'country', plural: 'countries' })}
                        . You are a:
                      </UI.Text>
                    )}
                <UI.Text size="title" color="chartreuse" weight="bold">
                  {getCategoryName(countries.length)}
                </UI.Text>
              </UI.VerticalLayout>
            )
          : <UI.Text size="subtitle" weight="bold">Start adding countries you've visited to see what kind of traveller you are!</UI.Text>}
      </UI.VerticalLayout>
    </div>
  );
};

export default TravelerStatus;
